<template>
    <div class="list_box">
        <div class="left_box">
            <div class="title">{{ locationLevel }}</div>
            <ul class="title_key">
                <li class="line_top" v-for="item in locationList" :key="item.id">{{item.areaName}}</li>
            </ul>
        </div>
        <div ref="scroll" class="right_box" :class="{'isScrolled': isScroll}" @scroll="scrollEvent">
            <div class="right_sroll_window">
                <div class="content_title_box" :style="{width: width + 'px'}">
                    <div v-for="(item, index) in titleList" :key="index" class="title_item" :style="{width: cellWidth + 'px'}">{{item}}</div>
                </div>
                <ul class="content_list" :style="{width: width + 'px'}">
                    <li v-for="(item, index) in contentData" :key="index" class="line_top">
                        <div v-for="(value, key, i) in item" :key="i" class="data" :style="{width: cellWidth + 'px'}">
                          {{value}}
                          </div>
                          <div v-if="titleList[titleList.length-1]==='操作'" @click="goComplain(index)" class="data oprate" :style="{width: cellWidth + 'px'}">
                          查看详情
                          </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'List',
        props: {
            listData: {
                type: Object,
                required: false,
                default: () => {}
            },
            locationList: {
                type: Array,
                required: false,
                default: () => []
            },
            titleList: {
                type: Array,
                required: false,
                default: () => []
            },
            contentData: {
                type: Array,
                required: false,
                default: () => []
            },
            locationLevel: {
                type: String,
                required: false,
                default: () => ''
            },
            cellWidth: {
                type: Number,
                default: () => 80
            }
        },
        data () {
            return {
                width: 0,
                isScroll: false,
            }
        },
        created(){
          console.log(this.titleList, 'titleList')
        },
        mounted () {
            this.computeWith()
            console.log(this.listData)
        },
        methods: {
            computeWith () {
                this.width = this.titleList.length * this.cellWidth
            },
            scrollEvent () {
                if (this.$refs.scroll.scrollLeft) {
                    this.isScroll = true
                } else {
                    this.isScroll = false
                }
            },
            // 跳投诉
            goComplain(index) {
              const { quarter, year, type } = this.$route.query;
              console.log('----这里的type是啥:', type);
              const { areaName, cityId } = this.locationList[index];
              if(type=='G') {
                this.$router.push(`/complaint/checkList?type=retaList&areaOne=${cityId}&fullAdress=${areaName}&year=${year}&quarter=${quarter}`);
              }else if(type == 'B3'||type=='I'||type =='J' || type == 'H') {
                this.$router.push(`/complaint/checkList?type=satisfiedList&areaOne=${cityId}&fullAdress=${areaName}&year=${year}&quarter=${quarter}`);
              }else if(type=='B1'||type=='B2') {
                this.$router.push(`/complaint/checkList?types=${type}&areaOne=${cityId}&fullAdress=${areaName}&year=${year}&quarter=${quarter}`);
              }
            }
        }
    }
</script>

<style lang="less" scoped>
    .list_box{
        background-color: #fff;

        &::before{
            content: '';
            display: block;
        }

        &::after{
            content: '';
            display: block;
            clear: both;
        }

        .left_box{
            width:102px;
            height:100%;
            background:rgba(255,255,255,1);
            box-shadow:0px 0px 15px 0px rgba(0,0,0,0.04);
            border-radius:3px 0px 0px 3px;
            float: left;
            text-align: center;
            color: #333333;
            font-size: 14px;
            .title {
              height: 46px;
              line-height: 46px;
              font-weight: bold;
            }
            >ul{
                margin: 0;
                padding: 0;
                list-style: none;
                li {
                  width: 100%;
                  height: 46px;
                  line-height: 46px;
                }
            }
        }

        .right_box{
            margin-left: 20%;
            overflow-x: scroll;

            &::-webkit-scrollbar{
                width: 0;
                height: 0;
            }

            .content_title_box{
                height: 46px;
                line-height: 46px;
                font-weight: bold;
                &::before{
                    content: '';
                    display: block;
                }

                &::after{
                    content: '';
                    display: block;
                    clear: both;
                }

                .title_item{
                    width: 90px;
                    text-align: center;
                    float: left;
                }
            }

            .content_list{
                width: 100%;
                margin: 0;
                padding: 0;
                list-style: none;

                >li{
                    width: 100%;
                    height: 46px;
                    line-height: 46px;
                    &::before{
                        content: '';
                        display: block;
                    }

                    &::after{
                        content: '';
                        display: block;
                        clear: both;
                    }

                    .data{
                        text-align: center;
                        float: left;
                    }
                }
            }
        }
    }
    .oprate {
      font-size: 12px;
      color: #36B374;
    }
    .isScrolled{
        // box-shadow: 10px 0px 10px rgba(0, 0, 0, 0.144) inset;
    }
</style>
